###
Route definitions for the whole app for consumption by vue-router
###
module.exports = [

	{ # Homepage
		name: 'home'
		path: '/'
		component: require '@/pages/home'
	}

	{ # Organization
		name: 'organization'
		path: '/:organization'
		component: require '@/pages/organization'
	}

]



// WEBPACK FOOTER //
// ./src/routing/routes.coffee